import React, { useEffect, useState } from "react";
import ReservationService from "../../../../api/ReservationService";
import ReservationCard from "./ReservationCard";
import "./ReservationList.css";

const PlanningReservations = () => {
  const [reservations, setReservations] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const itemsPerPage = 8;

  const fetchReservations = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await ReservationService.getCurrentUserReservationPlanning(page, itemsPerPage);
      const { data, total } = response.data;
      setReservations(data);
      setTotalPages(Math.ceil(total / itemsPerPage));
    } catch {
      setError("Une erreur s'est produite. Veuillez actualiser la page.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReservations();
  }, [page]);

  if (loading) {
    return (
      <div className="res-list-loading">
        <div className="res-list-spinner" />
      </div>
    );
  }

  if (error) {
    return <div className="res-list-error">{error}</div>;
  }

  if (reservations.length === 0) {
    return (
      <div className="res-list-empty">
        <span className="res-list-empty-icon">🎾</span>
        <p>Aucune réservation à venir</p>
      </div>
    );
  }

  return (
    <div className="res-list">
      <div className="res-list-items">
        {reservations.map((r) => (
          <ReservationCard key={r._id} reservation={r} past={false} />
        ))}
      </div>

      {totalPages > 1 && (
        <div className="res-list-pagination">
          <button
            className="res-page-btn"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
          >
            ‹
          </button>
          <span className="res-page-info">
            {page} / {totalPages}
          </span>
          <button
            className="res-page-btn"
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
          >
            ›
          </button>
        </div>
      )}
    </div>
  );
};

export default PlanningReservations;
